<template>
  <div
    class="mb-3"
    :class="{ 'has-error': !!validationMessage, 'position-relative': !!icon }"
  >
    <label
      v-if="label"
      :for="id"
      class="form-label form-label"
      :class="{ 'required': required, 'visually-hidden': labelHidded }"
    >{{ label }}</label>
    <span
      v-if="tooltip"
      class="visually-hidden"
    >{{ tooltip }}</span>
    <div class="input-group">
      <span
        v-if="icon"
        class="input-group-text"
      >
        <i
          :class="icon"
          aria-hidden="true"
        />
      </span>
      <slot />
      <div
        v-if="tooltip"
        v-tooltip.bottom="{
          value: tooltip,
          showDelay: 600
        }"
        aria-hidden="true"
        class="input-group-text"
      >
        <i class="fa-solid fa-circle-info" />
      </div>
      <span
        v-if="validationMessage"
        :id="validationSpanId"
        class="invalid-feedback"
      >
        {{ validationMessage }}
      </span>
    </div>
    <span v-if="disclaimer">
      <small class="text-muted">{{ disclaimer }}</small>
    </span>
  </div>
</template>

<script lang="ts" setup>
  import InputFieldElementIdGenerator from '@/VueComponents/SharedComponents/InputFields/utils/inputFieldElementIdGenerator';

  const props = withDefaults(defineProps<{
    id: string,
    label?: string,
    labelHidded?: boolean,
    validationMessage?: string,
    tooltip?: string,
    required?: boolean,
    errorId?: string,
    disclaimer?: string,
    icon?: string
  }>(), { required: false, label: undefined, validationMessage: undefined, tooltip: undefined,
          disclaimer: undefined, icon: undefined, errorId: undefined });

  const validationSpanId = props.errorId ?? InputFieldElementIdGenerator.getValidationMessageId(props.id);
</script>

<style scoped lang="scss">
.position-relative {
  position: relative;
}
</style>
